import restService from "../rest-service/RestService";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { ObjectFeaturesEnum } from "../../common/enums/ObjectFeaturesEnum";
import { ITagValue } from "../../common/models/ITagValue";
import { IGaugeSheetColumnSetData, IGaugeSheetConfiguration, IGaugeSheetDataRestQueryParams, ILiquidProductionCalculation } from "./Models";
import { ManualEntryFeatureEnum } from "../../common/enums/ManualEntryFeatureEnum";

interface IGaugeSheeCalculateProductionQueryParams {
    startDate: Date,
    endDate: Date
}


export interface IGaugeSheetExportOptions {
    mimeType: ApplicationMimeTypesEnum;
    notificationKey: string;
    beginDate: Date;
    endDate: Date;
    includeRunTickets: boolean;
    includeGaugeSheets: boolean;
    email?: string;
    filterDeviceIDList?: number[];
}

const GaugeSheetDataService = {

    getData: async function(
        contextGroupID: number, 
        deviceID: number,
        date?: Date,
        abortSignal?: AbortSignal): Promise<IGaugeSheetColumnSetData> {

        var queryParams: IGaugeSheetDataRestQueryParams = {
            dateTime: date
        };
        const path =`/groups/${contextGroupID}/devices/${deviceID}/gaugesheet/data`;
        const response = await restService.get<IGaugeSheetColumnSetData, IGaugeSheetDataRestQueryParams>(
                path,
                abortSignal,                 
                queryParams
            );

        // adjust the features, this app uses ObjectFeaturesEnum for consistency.  The gaugesheet data call
        // uses a slightly different enum.  Rather than change backend functionality which will break existing
        // app, we'll fix it here.
        response.data.columns.forEach(o => {
            if ((o.features & ManualEntryFeatureEnum.MemoModify) > 0) {
                o.features &= ~ManualEntryFeatureEnum.MemoModify;
                o.features |= ObjectFeaturesEnum.MemoModify;
            }
        })

        return {...response.data,
            deviceID: deviceID
        };
    },

    getConfiguration: async function(
        contextGroupID: number, 
        deviceID: number,
        abortSignal?: AbortSignal): Promise<IGaugeSheetConfiguration> {

        const path =`/groups/${contextGroupID}/devices/${deviceID}/gaugesheet/config`;
        const response = await restService.get<IGaugeSheetConfiguration>(
                path,
                abortSignal        
            );

        return response.data;            
    },
    caclulateProduction: async function(contextGroupID: number, 
        deviceID: number,
        startDate: Date,
        endDate: Date,
        data: ILiquidProductionCalculation[],
        abortSignal?: AbortSignal): Promise<ITagValue[]> {

            const queryParams: IGaugeSheeCalculateProductionQueryParams = {
                startDate,
                endDate
            }

            const path =`/groups/${contextGroupID}/devices/${deviceID}/gaugesheet/calculate`;
            const response = await restService.put<ILiquidProductionCalculation[], IGaugeSheeCalculateProductionQueryParams, ITagValue[]>(
                    path,
                    data,
                    abortSignal,
                    queryParams    
                );
    
            return response.data;            
    },
    deleteTagValue: async function(contextGroupID: number, 
        deviceID: number,
        value: ITagValue,
        abortSignal?: AbortSignal): Promise<ITagValue[]> {

        const path =`/groups/${contextGroupID}/devices/${deviceID}/gaugesheet/value`;
        const response = await restService.delete<ITagValue, any>(
                path,
                abortSignal,
                undefined, 
                value,
            );

        return response.data as ITagValue[];                        
    },
    export: async function (contextGroupID: number, 
        deviceID: number, 
        date: Date, 
        notificationKey: string, 
        mimeType: ApplicationMimeTypesEnum,
        filterIDList: number[] | undefined,
        abortSignal?: AbortSignal): Promise<string> {

        //date.day(1);  this is the first day of the week
        const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
        const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);

        const exportParams: IGaugeSheetExportOptions = {
            mimeType: mimeType,
            notificationKey: notificationKey,
            beginDate: startDate,
            endDate: endDate,
            includeRunTickets: true,
            includeGaugeSheets: true,
            filterDeviceIDList: filterIDList
        };

        const path =`/groups/${contextGroupID}/devices/${deviceID}/gaugesheet/export`;
        const response = await restService.post<IGaugeSheetExportOptions, string>(
                path,
                exportParams,
                abortSignal
            );

        return response.data;            
    },
    exportGroupData: async function (contextGroupID: number, 
        exportOptions: IGaugeSheetExportOptions,        
    ): Promise<void> {

        const path =`/groups/${contextGroupID}/gaugesheet/export`;
        await restService.post<IGaugeSheetExportOptions, string>(
                path,
                exportOptions
            );
    },



    //     public exportGroupData(groupID: number, exportOptions: DataEntryModels.IGaugeSheetExportOptions): Services.RestPromise<string> {
//         var path: string = [
//             "groups",
//             groupID,
//             "gaugesheet",
//             "export"
//         ].join("/");

//         return this._restService.post(path, exportOptions).then((data: Services.IRestResponse<string>) => {
//             return data.entity;
//         });
//     }
// }


};

export default GaugeSheetDataService;


// // <reference path="../services.interfaces.ts"/>
// /// <reference path="../../../typings/when/when.d.ts" />
// "use strict";

// import Enums = require("lib/elynx/core/enums/enums");
// import Models = require("lib/elynx/core/models/models");
// import DataEntryModels = require("lib/elynx/core/models/data-entry.models");
// import Services = require("services/services.interfaces");
// import moment = require("moment");

// class GaugeSheetDataService implements Services.IGaugeSheetDataService {

//     constructor(private _restService: Services.IRestService) {
//     }


//     public getData(groupID: number, deviceID: number, date?: moment.Moment): Services.RestPromise<DataEntryModels.IGaugeSheetColumnSetData> {
//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "gaugesheet",
//             "data"
//         ].join("/");


//         var getQueryParams: DataEntryModels.IGaugeSheetDataRestQueryParams = {
//             dateTime: date
//         };
//         return this._restService.get<any, DataEntryModels.IGaugeSheetDataRestQueryParams>(path, getQueryParams).then((data: Services.IRestResponse<any>) => {
//             return data.entity;
//         });
//     }

//     public getRunTicketData(groupID: number, deviceID: number, tankID?: number, date?: moment.Moment): Services.RestPromise<Array<DataEntryModels.IRunTicketModel>> {

//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "runtickets"
//         ].join("/");

//         var getQueryParams: DataEntryModels.IGaugeSheetDataRestQueryParams = {
//             dateTime: date,
//             tankID: tankID
//         };
//         return this._restService.get<any, DataEntryModels.IGaugeSheetDataRestQueryParams>(path, getQueryParams).then((data: Services.IRestResponse<Array<DataEntryModels.IRunTicketModel>>) => {
//             return data.entity;
//         });
//     }

//     public getConfiguration(groupID: number, deviceID: number): Services.RestPromise<DataEntryModels.IGaugeSheetConfiguration> {

//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "gaugesheet",
//             "config"
//         ].join("/");

//         return this._restService.get<DataEntryModels.IGaugeSheetConfiguration>(path).then((data: Services.IRestResponse<any>) => {
//             return data.entity;
//         });
//     }


//     public saveTagValues(groupID: number, deviceID: number, values: Array<Models.ITagValueModel>, convertToContractDay?: boolean): Services.RestPromise<Array<Models.ITagValueModel>> {

//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "gaugesheet",
//             "values"
//         ].join("/");

//         var queryParams: DataEntryModels.ITagValueParams = {
//             convertToContractday: convertToContractDay
//         };
//         return this._restService.put(path, values, queryParams).then((data: Services.IRestResponse<Array<Models.ITagValueModel>>) => {
//             return data.entity;
//         });
//     }

//     public deleteTagValue(groupID: number, deviceID: number, value: Models.ITagValueModel): Services.RestPromise<Array<Models.ITagValueModel>> {

//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "gaugesheet",
//             "value"
//         ].join("/");

//         return this._restService.delete(path, null, value).then((data: Services.IRestResponse<Array<Models.ITagValueModel>>) => {
//             return data.entity;
//         });
//     }


//     public calculateProduction(groupID: number, deviceID: number, startDate: moment.Moment, endDate: moment.Moment, data: Array<DataEntryModels.LiquidProductionCalculationModel>): Services.RestPromise<Array<Models.ITagValueModel>> {

//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "gaugesheet",
//             "calculate"
//         ].join("/");

//         var queryParams: DataEntryModels.IGaugeSheeCalculateProductionQueryParams = {
//             startDate: startDate,
//             endDate: endDate
//         };
//         return this._restService.put(path, data, queryParams).then((data: Services.IRestResponse<Array<Models.ITagValueModel>>) => {
//             return data.entity;
//         });
//     }

//     public export(groupID: number, deviceID: number, date: moment.Moment, notificationKey: string, mimeType: Enums.ApplicationMimeTypesEnum): Services.RestPromise<string> {
//         var path: string = [
//             "groups",
//             groupID,
//             "devices",
//             deviceID,
//             "gaugesheet",
//             "export"
//         ].join("/");

//         //date.day(1);  this is the first day of the week
//         date = moment(new Date(date.toDate().getFullYear(), date.toDate().getMonth(), 1));

//         var endDate: moment.Moment = moment(date);
//         endDate.month(date.month() + 1);

//         var queryParams: DataEntryModels.IGaugeSheetExportOptions = {
//             mimeType: mimeType,
//             notificationKey: notificationKey,
//             beginDate: date,
//             endDate: endDate,
//             includeRunTickets: true,
//             includeGaugeSheets: true
//         };

//         return this._restService.post(path, queryParams).then((data: Services.IRestResponse<string>) => {
//             return data.entity;
//         });
//     }

//     public exportGroupData(groupID: number, exportOptions: DataEntryModels.IGaugeSheetExportOptions): Services.RestPromise<string> {
//         var path: string = [
//             "groups",
//             groupID,
//             "gaugesheet",
//             "export"
//         ].join("/");

//         return this._restService.post(path, exportOptions).then((data: Services.IRestResponse<string>) => {
//             return data.entity;
//         });
//     }
// }

// var instance: Services.IGaugeSheetDataService;

// function factory(restService: Services.IRestService) {
//     "use strict";

//     if (!instance) {
//         instance = new GaugeSheetDataService(restService);
//     }
//     return instance;
// }

// export = factory;